import moment from 'moment'
import React, { useEffect, useState } from 'react'
import flightIcon from '../../../../assets/images/flight.svg'
import siteLogo from '../../../../assets/images/logo.png'
import './index.scss'
import { getWeightUnit } from '../../../../constants'
import { getShippingItems } from '../../../../services/searchPanelServices'
import { populateBookingDetails } from '../../../SearchPanel/templateUtils'
import {
	setToSessionStorage,
	getBase64Encoded,
	clearItemFromSessionStorage,
} from '../../../../utils/StorageUtils'
import { validateBooking } from './../../../../services/quoteServices'
import { useHistory } from 'react-router-dom'
import RouteDetails from '../PrintBooking/RouteDetails'
import MESSAGES from '../../../../constants/Messages'
import { useTranslation } from 'react-i18next'
import editIcon from '../../../../assets/images/edit.png'
import FlightDetails from "../../../FlightDetails/FlightDetails"
import { useDispatch, useSelector } from "react-redux";
import { setMasterDataDetails } from "../../../../redux/actions/masterDataActions"
import sessionKeys from '../../../../constants/sessionKeys'
const FlightDetailsView = ({
	bookingDetails,
	bookingResponse,
	setIsLoading,
	awbNo,
	setIsPastBooking,
	setPastBookingMessage,
	setEnquiredPresent,
	isMutlipleBooking,
	toBeProcessedData
}) => {

	//for multilingual
	const [t] = useTranslation(['labels', 'errors'])

	const [routes, setRoutes] = useState('')
	const [flyingHrs, setFlyingHrs] = useState('')
	const [departureDateTime, setDepartureDateTime] = useState(null)
	const [arrivalDateTime, setArrivalDateTime] = useState(null)
	const [rateDetails, setRateDetails] = useState([])

	const history = useHistory()
	const masterData = useSelector(state => state?.masterData);
	const dispatch = useDispatch();

	const getFormattedTtime = (dateToChange) => {
		return moment(dateToChange).format('HH:mm')
	}

	useEffect(() => {
		if (bookingDetails && bookingDetails.bookingFlightDetails)
			getFlightTime(bookingDetails)
		if (bookingDetails && bookingDetails.chargeDetails) {
			setRateDetails(bookingDetails.chargeDetails)
		}
		if (
			bookingDetails.bookingFlightDetails &&
			bookingDetails.bookingFlightDetails.length > 0
		) {
			setRoutes(bookingDetails.bookingFlightDetails.length - 1)
		}
	}, [bookingDetails])

	const getFlightTime = (bookingDetails) => {
		const length = bookingDetails.bookingFlightDetails.length

		setDepartureDateTime(
			moment(bookingDetails.bookingFlightDetails[0].segmentDepartureDate)
		)
		setArrivalDateTime(
			moment(bookingDetails.bookingFlightDetails[length - 1].segmentArrivalDate)
		)
	}

	const handleModifyFlight = async () => {
		const status = checkPastBooking(bookingDetails.shippingDate)
		if (status) {
			setIsPastBooking(status)
			setPastBookingMessage(MESSAGES.ERR_MODIFY_PAST_BOOKING)
			window.scrollTo(0, 0)
		} else {
			clearItemFromSessionStorage('awbNumber')
			clearItemFromSessionStorage('flightSelected')
			clearItemFromSessionStorage('bookingDetails')
			clearItemFromSessionStorage('searchObject')

			getBookingData()
			// To disable modify booking for spot rate attached bookings.
			// if (bookingDetails?.chargeDetails?.spotRate && bookingDetails?.chargeDetails?.spotRateCode &&) {
			// 	setIsPastBooking(true)
			// 	setPastBookingMessage(MESSAGES.ERR_MODIFY_BOOKING)
			// 	window.scrollTo(0, 0)
			// } else {
			// 	getBookingData()
			// }
		}
	}

	const validateBookingDetails = async (bookingData, awbNumber) => {
		const validateBookingResponse = await validateBooking(
			bookingData,
			null,
			awbNumber
		)
			.then((response) => {
				if (response && response.bookingDetails) {
					return response.bookingDetails
				} else if (
					response &&
					response.errorDetails &&
					response.errorDetails.length > 0
				) {
					return response.errorDetails[0]
				} else {
					return null
				}
			})
			.catch((error) => {
				console.log(error)
				setIsLoading(false)
				return null
			})
		return validateBookingResponse
	}

	const getBookingData = async () => {
		setIsLoading(true)
		// let shippingItemsList = await getShippingItems()
		let shippingItemsList = [];
		if (masterData?.shippingItemsMaster && masterData.shippingItemsMaster.length > 0) {
			// productList = masterData.productsMaster;
			shippingItemsList = [...masterData.shippingItemsMaster];
		} else {
			shippingItemsList = await getShippingItems();
			if (shippingItemsList && shippingItemsList.length > 0) {
				const masterDataPayload = {
					shippingItemsMaster: shippingItemsList
				};
				dispatch(setMasterDataDetails(masterDataPayload));
				shippingItemsList = [...shippingItemsList];
			}
		}
		if (shippingItemsList) {
			shippingItemsList = shippingItemsList.sort((a, b) => {
				if (a.description < b.description) {
					return -1
				}
				if (a.description > b.description) {
					return 1
				}
				return 0
			})
		}

		if (shippingItemsList && bookingResponse) {
			const data = await populateBookingDetails(
				bookingResponse,
				shippingItemsList,
				true,
				setIsLoading
			)
			if (data) {
				data.isModifyBooking = true
				data.awbNo = awbNo
				data.densityInSelectedUnit = bookingDetails.bookingCargoDetails.density

				// Saving Data for modify flow.
				clearItemFromSessionStorage(sessionKeys.UPDATE_BOOKING_DATA)
				let additionalFlightDetails;
				const { lastAcceptanceTime, earliestDeliveryTime, dropOffAddress, pickUpAddress } = bookingDetails || {}
				if (lastAcceptanceTime || earliestDeliveryTime || dropOffAddress || pickUpAddress) {
					additionalFlightDetails = {
						lastAcceptanceTime: lastAcceptanceTime || null,
						earliestDeliveryTime: earliestDeliveryTime || null,
						dropOffAddress: dropOffAddress || null,
						pickUpAddress: pickUpAddress || null
					}
				}
				const initialAWBData = {
					origin: bookingDetails.origin,
					destination: bookingDetails.destination,
					shippingDate: bookingDetails.shippingDate,
				}
				setToSessionStorage(sessionKeys.UPDATE_BOOKING_DATA, getBase64Encoded({ awbFlightDetails: bookingDetails?.bookingFlightDetails, additionalFlightDetails, initialAWBData }))


				setToSessionStorage('searchObject', getBase64Encoded(data))
				if (data.additionalInfo) {
					setToSessionStorage(
						'additionalFormData',
						getBase64Encoded(data.additionalInfo)
					)
				}
				history.push(`/booking/flightlist`)

				/*const validateBookingResponse = await validateBookingDetails(
					data,
					awbNo.trim()
				)
				if (
					validateBookingResponse &&
					!validateBookingResponse.errorDescription
				) {
					setToSessionStorage('searchObject', getBase64Encoded(data))
					if (data.additionalInfo) {
						setToSessionStorage(
							'additionalFormData',
							getBase64Encoded(data.additionalInfo)
						)
					}
					history.push(`/booking/flightlist`)
				} else {
					history.push({
						pathname: '/manage-booking/list',
						state: {
							modifyBooking: {
								status: false,
								awbNo: awbNo,
								message:
									validateBookingResponse &&
									validateBookingResponse.errorDescription
										? validateBookingResponse.errorDescription
										: '',
							},
						},
					})
				}*/
			}
		}
		setIsLoading(false)
	}

	const checkPastBooking = (shippingDate) => {
		const today = moment(new Date(), 'ddd DD MMM')
		return shippingDate && moment(shippingDate, 'ddd DD MMM').isSameOrBefore(today)
	}

	function mapBookingDetailsToDestinationAirport(bookingDetails) {
		if (!bookingDetails) return {};

		// Map bookingFlightDetails to flightSegmentList
		const flightSegmentList = Array.isArray(bookingDetails.bookingFlightDetails)
			? bookingDetails.bookingFlightDetails.map(segment => ({
				flightCarrierCode: segment.carrierCode,
				flightNumber: segment.flightNumber,
				flightDate: segment.flightDate,
				flightType: segment.flightType,
				segmentOrigin: segment.segmentOrigin,
				segmentDestination: segment.segmentDestination,
				segmentDepartureDateTime: segment.segmentDepartureDate,
				segmentArrivalDateTime: segment.segmentArrivalDate,
				departureDateTime: segment.segmentDepartureDate, // For popup
				arrivalDateTime: segment.segmentArrivalDate,     // For popup
				aircraftType: segment.aircraftType,
				aircraftClassification: segment.aircraftClassification,
				flyingHours: segment.flyingHours,
				layoverTime: segment.layoverTime,
				originCityName: segment.originCityName,
				destCityName: segment.destinationCityName,
				originAirportName: segment?.originAirportName,
				destAirportName: segment?.destinationAirportName,
			}))
			: [];

		const ratingDetails = Array.isArray(bookingDetails.bookingRateDetails)
			? bookingDetails.bookingRateDetails.map(rate => ({
				currency: rate.currency || '',
				grandTotal: rate.grandTotal || 0,
				totalRate: rate.totalRate || 0,
				allInRate: rate.allInRate || false,
				rateType: rate.rateType || '',
				rateClass: rate.rateClass || '',
				rateDescription: rate.rateDescription || '',
				minimumCharge: rate.minimumCharge || 0,
				otherCharges: rate.otherCharges || [],
			}))
			: [];

		return {

			flightSegmentList,
			departureDateTime: flightSegmentList[0]?.segmentDepartureDateTime || '',
			arrivalDateTime: flightSegmentList[flightSegmentList.length - 1]?.segmentArrivalDateTime || '',
			origin: bookingDetails.origin,
			destination: bookingDetails.destination,
			allotmentAvailable: bookingDetails.allotmentAvailable,
			overBookingAllowed: bookingDetails.overBookingAllowed,
			overHangShipment: bookingDetails.overHangShipment,
			bigShipment: bookingDetails.bigShipment,
			isForceQueued: bookingDetails.isForceQueued,
			warningMessages: bookingDetails.warningMessages,
			cumulativeJourneyTime: bookingDetails.cumulativeJourneyTime,
			ratingDetails,
			service: bookingDetails.service,
			priceClass: bookingDetails.priceClass,
			originCityName: bookingDetails.originCityName,
			destCityName: bookingDetails.destCityName,
			originAirportName: bookingDetails.originAirportName,
			destAirportName: bookingDetails.destinationAirportName,

			// For FlightDetailsPopup
			dropOffAddress: bookingDetails.dropOffAddress || {},
			pickUpAddress: bookingDetails.pickUpAddress || {},
			lastAcceptanceTime: bookingDetails.lastAcceptanceTime,
			earliestDeliveryTime: bookingDetails.earliestDeliveryTime,

		};
	}

	return (
		<div className='flight-detail-wrapper'>
			<div className='custm_mb_view_booking d-flex align-items-center justify-content-between flight-detail-header mb-0'>
				<div className=''>
					<h3 className='page-sub-head-view-booking'>{t('VIEWBKG.FLIGHT_DTS')}</h3>
				</div>
				{
					bookingDetails.bookingStatus &&
					bookingDetails.bookingStatus !== 'X' && !isMutlipleBooking && (
						<div className='portal-col link-align-center'>
							<div
								className='cargo-edit-link pr-0'
								onClick={handleModifyFlight}
							>
								<span>{t('COMMON.EDIT')}</span>
							</div>
							{/* <span
							className='primary-details-wrapper_modify-mobile d-lg-none d-flex'
							onClick={handleModifyFlight}
						>
								<img src={editIcon} alt='modify-mobile' title='modify-mobile' />
							</span> */}
						</div>
					)
				}
			</div>

			<div className='flight-detail-inner-wrapper '>
				{/* <RouteDetails bookingDetails={bookingDetails} viewFlag={false} /> */}
				<FlightDetails
					setEnquiredPresent={setEnquiredPresent}
					destinationAirport={mapBookingDetailsToDestinationAirport(bookingDetails)}
					showChooseButton={false}
					showDropoffPickup={false}
					showRightSection={false}
					showFooter={true}
					toBeProcessedData={toBeProcessedData}
				/>
			</div>

			<div></div>
		</div>
	)
}
export default FlightDetailsView
